module.exports = __webpack_public_path__ + "img/pyhton.290992c1.svg";